import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useAdminContext } from '../../../../context/adminContext';
import {  createOrUpdateTrainStationApi,  getAllTrainStationPGApi, removeTrainStationByIdApi, } from '../../../../utils/ApiEndpointFunctions';
import Header from '../../../common/Header';
import { trainStationInitialValue, trainStationValidationSchema } from "../../../common/Validation"
import Pagination from '../../../common/Pagination';
import Spinwheel from '../../../common/Spinwheel';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-hot-toast';
import { debounce } from 'lodash';
import RemoveModal from '../../../common/RemoveModal';
import { useParams } from 'react-router-dom';
import AddOrUpdateStationModal from './AddOrUpdateStation';


function AllTrainStation() {
  const navigate = useNavigate()
  const [tableSpin, setTableSpin] = useState(true);
  const [data, setData] = useState([]);
  let [selectedPage, setSelectPage] = useState(0);
  const [page, setPage] = useState(0);
  const param = useParams()
  const addOrUpdateStationModalId = "addOrUpdateStationModalId"
  const removeStationModalId = "removeStationModalId"
  const [selectedStation, setSelctedStation] = useState(null)
  const [addLoader, setAddLoader] = useState(false)
  const limit = 10;

  const getAllTrainStationList = async (selectedPage, search) => {
    try {
      setTableSpin(false)
      const res = await getAllTrainStationPGApi(search || "", selectedPage + 1, limit)
      if (res.status === 200) {
        setData(res.data?.data?.data)
        const totaldata = res.data?.data?.totalData

        setPage(Math.ceil(totaldata / limit));
      }
      setTableSpin(true)
    } catch (error) {
      setTableSpin(true)
    }
  }

  const handlePageClick = (event) => {
    setSelectPage(event.selected);
    getAllTrainStationList(event.selected)
  };

  const handleRemoveMovie = async () => {
   try {
     const res = await removeTrainStationByIdApi(selectedStation);
     if (res?.status === 200) {
       toast.success(res.data?.message)
       getAllTrainStationList(0)
       setSelctedStation(null)
       document.getElementById(removeStationModalId).click()
     }
   } catch (error) {
     toast.error(error?.response?.data?.message);
   }
 }

  const handleSubmit = async (values) => {
    try {
      let payload ={
         ...values,
      }
      setAddLoader(true)
      const res = await createOrUpdateTrainStationApi(payload);
      if (res?.status === 200) {
        toast.success(res.data?.message)
        setAddLoader(false)
        getAllTrainStationList(0)
        document.getElementById(addOrUpdateStationModalId).click()
        setSelctedStation(null)
       formik.resetForm()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setAddLoader(false)
    }
  }


  const formik = useFormik({
    initialValues: trainStationInitialValue,
    onSubmit: handleSubmit,
    validationSchema: trainStationValidationSchema,
  })

  const onChange = async (e) => {
    let search = e.target.value;
    getAllTrainStationList(0, search)
  };

  const debouncedOnChange = debounce(onChange, 500);

  useEffect(() => {
      getAllTrainStationList(selectedPage)   
  }, [])




  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Train" />
        {/* CARDS */}
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <Link to={"/ticket/train/tickets"} className="breadcrumb-item active" aria-current="page">
                Train Ticket
                </Link>
                <Link to={"/ticket/train/all-train"} className="breadcrumb-item active" aria-current="page">
                Trains
                </Link>
                <li  className="breadcrumb-item active" aria-current="page">
                Stations
                </li>
              </ol>
            </nav>
            <div className="mb-4" style={{ textAlign: "end" }}>
              <div className='d-flex justify-content-end gap-2' style={{ display: "-webkit-inline-box" }}>
                <div className='d-flex gap-2 align-items-center justify-content-center'>
                <button data-bs-toggle="modal" data-bs-target={`#${addOrUpdateStationModalId}`} onClick={() =>formik.resetForm()} className="btn-custom w-auto" style={{ cursor: "pointer" }}>
                  Add
                  </button>

                  <div className="position-relative">
                    <input
                      className="form-search me-3"
                      type="search"
                      name=""
                      onChange={debouncedOnChange}
                      placeholder="Search"
                    />
                    <img
                      className="users-search"
                      src="/images/Icon feather-search.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div className="card p-3 table-responsive" >
              <table className="table table-hover table-nowrap card-table">
                <thead>
                  <tr>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        S.No
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Name
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Alias
                      </span>
                    </th>
                    <th></th>


                  </tr>
                </thead>
                {
                  tableSpin ?
                    <tbody className="list fs-base">
                      {data?.length > 0 ? data?.map((ele, index) => {
                        return (<tr key={index} >
                          <td>{index + 1}</td>
                          <td className='position-relative'>
                         
                            {ele?.name?.length > 30 ? <span>
                              
                              <div className="tooltip1 item-name text-reset" >
                              {ele?.name?.substr(0, 30)}...
                              <div className='wrapper'>
                                <div className="tooltip1-text">{ele?.name}</div>
                              </div>
                              </div>
                             
                            </span> :
                              <span>{ele?.name || "-"}</span>}
                          </td>
                          
                          <td className='position-relative'>
                            {ele?.alias || "-"}
                          </td>
                          <td className="text-end">
                            {ele?.status?.toLowerCase() != "transferred" &&
                              <div className="dropdown">
                                <span
                                  className="dropdown-ellipses dropdown-toggle"
                                  role="button"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="fe fe-more-vertical" />
                                </span>
                                <div className="dropdown-menu dropdown-menu-end">
                                  <div data-bs-toggle="modal" data-bs-target={`#${addOrUpdateStationModalId}`} className=' dropdown-item' style={{ cursor: "pointer" }} onClick={() => {formik.setValues(ele) }}>
                                    View / edit
                                  </div>
                                  <div data-bs-toggle="modal" data-bs-target={`#${removeStationModalId}`} className=' dropdown-item' style={{ cursor: "pointer" }} onClick={() => { setSelctedStation(ele?._id) }}>
                                    Remove
                                  </div>
                                </div>
                              </div>}
                          </td>
                        </tr>
                        )
                      }) : <tr align="center">
                        <td colSpan="9">
                          <h1>
                            Data Not Found
                          </h1>
                        </td>
                      </tr>}
                    </tbody> : (
                      <tbody>
                        <tr align="center">
                          <td colSpan="9">
                            <Spinwheel />
                          </td>
                        </tr>
                      </tbody>
                    )
                }
              </table>
            </div>
            <div className="d-flex justify-content-center">
              {data?.length > 0 ? <Pagination
                clickHandler={handlePageClick}
                page={page}
                selectedPage={selectedPage}
              />
                : null}
            </div>
          </div>
          <AddOrUpdateStationModal modalId={addOrUpdateStationModalId} formik={formik} addLoader={addLoader}/>
          <RemoveModal removeHandler={handleRemoveMovie} modalId={removeStationModalId} message={"Are you sure you want to remove?"} />
        </div>
      </div>
    </>
  )
}

export default AllTrainStation